{
  "orders": {
    "title": "Job Work Order",
    "subtitle": "Send materials out to a subcontracting vendor and track what comes back — from the output material's BOM or picked directly.",
    "add": "New Job Work Order",
    "edit": "Edit",
    "view": "View",
    "release": "Release",
    "close": "Close",
    "cancel": "Cancel",
    "save": "Save",
    "table": {
      "number": "Order No.",
      "vendor": "Job Work Vendor",
      "outputMaterial": "Output Material",
      "plannedQty": "Planned Qty",
      "warehouse": "Warehouse",
      "date": "Order Date",
      "lines": "Materials",
      "sentPending": "Sent / To Send",
      "receivedExpected": "Received / Expected",
      "rejectedChip": "{{qty}} rejected",
      "status": "Status",
      "client": "Client"
    },
    "lineTable": {
      "material": "Material",
      "requiredQty": "To Send",
      "issuedQty": "Sent",
      "pendingQty": "Pending"
    },
    "reconciliation": {
      "title": "Reconciliation",
      "sentSide": "Materials Sent Out",
      "returnedSide": "Output Received Back",
      "toSend": "To send",
      "sent": "Sent so far",
      "pendingToSend": "Still to send",
      "expected": "Expected back",
      "received": "Received",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "pendingToReceive": "Still at vendor",
      "footnote": "The two sides are different materials in different units — they are tracked separately, never netted against each other. Rejected quantity never becomes usable stock.",
      "linesTitle": "Materials to Send"
    },
    "modes": {
      "Bom": "From BOM",
      "Manual": "Pick Materials Manually"
    },
    "form": {
      "mode": "How to choose what to send",
      "modeLockedHint": "Only {{mode}} is switched on for this company (Process Configuration → Job Work).",
      "vendor": "Job Work Vendor",
      "noVendorsHint": "No suppliers are marked as Job Work Vendors yet — tick that on the Supplier master first.",
      "warehouse": "Warehouse",
      "outputMaterial": "Output Material (what comes back)",
      "outputMaterialBomHint": "Only items with an active BOM are listed. Its BOM decides which materials get sent.",
      "noActiveBomsHint": "No active BOMs exist yet — create one under Masters → Bill of Materials, or switch to picking materials manually.",
      "bomChildrenTitle": "Materials that will be sent ({{bom}})",
      "plannedQty": "Planned Output Qty",
      "client": "Client",
      "expectedReturnDate": "Expected Return Date",
      "remarks": "Remarks",
      "lines": "Materials to Send",
      "material": "Material",
      "qty": "Qty",
      "addLine": "Add Material",
      "bomModeHint": "The materials to send will be worked out from the output material's active BOM, scaled to the planned quantity."
    }
  },
  "issue": {
    "title": "Job Work Issue",
    "subtitle": "Hand materials over to the job work vendor against a released order — this is where stock leaves your warehouse.",
    "selectOrder": "Job Work Order",
    "noOrdersHint": "No released job work orders are waiting to be sent. Release an order first.",
    "outputHint": "Expecting back: {{material}} — {{qty}}",
    "requiredIssued": "To send: {{required}} · Already sent: {{issued}}",
    "pending": "Pending: {{qty}}",
    "qtyToSend": "Qty to Send",
    "barcodeModeHint": "Pick list {{pickList}} — scan each unit's barcode to send it. Quantities are fixed to the scanned label.",
    "manualModeHint": "Pick list {{pickList}} — materials are pre-resolved to their FIFO location. Enter the quantity to send for each.",
    "scanBarcode": "Scan Barcode",
    "scanBarcodeHelper": "Scan or type the label's barcode to confirm you're sending the physical unit in hand.",
    "scannedOfTotal": "{{scanned}} / {{total}}",
    "expectedBarcode": "Expected barcode: {{barcode}}",
    "scanned": "scanned",
    "noBarcodeBlocked": "Barcode Required is enabled but this item has no barcode or printed label to scan. Set a barcode on the item, or print Job Work labels for it.",
    "location": "Location",
    "batch": "Batch",
    "packingQty": "boxes",
    "selectLocation": "Location / Batch",
    "noBatch": "No batch",
    "outwardDcNo": "Outward DC No.",
    "vehicleNo": "Vehicle No.",
    "remarks": "Remarks",
    "issueButton": "Issue to Vendor",
    "issuing": "Issuing...",
    "genericError": "Could not issue the materials. Please check the quantities and try again.",
    "historyTitle": "Issue History",
    "table": {
      "number": "Issue No.",
      "order": "Job Work Order",
      "vendor": "Vendor",
      "warehouse": "Warehouse",
      "date": "Issue Date",
      "dcNo": "Outward DC",
      "issuedBy": "Issued By",
      "lines": "Materials"
    }
  },
  "receipt": {
    "title": "Job Work Receipt",
    "subtitle": "Receive the processed material back from the vendor against the job work order — same or converted material code, with quantity variance.",
    "add": "New Receipt",
    "view": "View",
    "cancel": "Cancel",
    "noOrdersHint": "No released job work orders are waiting to be received. Release an order first.",
    "expectedHint": "Expecting back: {{material}} — {{qty}}",
    "genericError": "Could not record the receipt. Please check the quantities and try again.",
    "table": {
      "number": "Receipt No.",
      "order": "Job Work Order",
      "vendor": "Vendor",
      "warehouse": "Warehouse",
      "date": "Receipt Date",
      "dcNo": "Vendor DC No.",
      "lines": "Materials",
      "status": "Status",
      "material": "Material",
      "expiryDate": "Expiry Date",
      "qcStatus": "QC Status"
    },
    "form": {
      "order": "Job Work Order",
      "vendorDcNo": "Vendor DC No.",
      "vehicleNo": "Vehicle No.",
      "lines": "Materials Received",
      "material": "Material (same or converted code)",
      "received": "Received",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "batchNo": "Batch No.",
      "unitCost": "Unit Cost",
      "addLine": "Add Material",
      "generate": "Record Receipt"
    }
  },
  "qc": {
    "title": "Job Work QC",
    "subtitle": "Inspect what came back from the job work vendor — mandatory or optional checkpoints, quantity-wise accept/reject.",
    "cancel": "Cancel",
    "view": "View",
    "inspect": "Inspect",
    "tabs": {
      "open": "Open",
      "completed": "Completed"
    },
    "table": {
      "receipt": "Receipt No.",
      "material": "Material",
      "batch": "Batch",
      "qty": "Received Qty",
      "vendor": "Vendor",
      "status": "Status"
    },
    "quickActions": {
      "hold": "Hold",
      "rework": "Rework"
    },
    "dialog": {
      "subtitle": "{{receipt}} · Batch {{batch}}",
      "mandatory": "Mandatory",
      "mustBe": "must be",
      "actualValue": "Actual Value",
      "pass": "Pass",
      "fail": "Fail",
      "noCheckpoints": "No checkpoints are configured for this item — record a direct decision below.",
      "checkpointsNotRecorded": "This task was finalized without recording individual checkpoint results.",
      "mandatoryCheckpointsRequired": "All mandatory checkpoints must be recorded before submitting: {{names}}",
      "rejections": "Rejections",
      "addRejection": "Add Rejection",
      "noRejections": "No rejections recorded — the full received quantity will be accepted.",
      "reason": "Reason",
      "rejectQty": "Reject Qty",
      "qtySummary": "Received {{received}} · Rejected {{rejected}} · Accepted {{accepted}}",
      "rejectedExceedsReceived": "rejected quantity cannot exceed received quantity",
      "remarks": "Remarks",
      "hold": "Hold",
      "rework": "Rework",
      "saveResults": "Save Results",
      "submit": "Submit Report"
    }
  },
  "putaway": {
    "title": "Job Work Putaway",
    "subtitle": "Shelve accepted job work stock into a location — manual quantity split, or barcode-wise once Job Work labels are printed.",
    "cancel": "Cancel",
    "confirm": "Confirm Putaway",
    "table": {
      "receipt": "Receipt No.",
      "material": "Material",
      "batch": "Batch",
      "qty": "Qty",
      "progress": "{{allocated}} of {{total}} put away",
      "warehouse": "Warehouse",
      "suggested": "Suggested Location",
      "status": "Status"
    },
    "dialog": {
      "title": "Confirm Putaway",
      "subtitle": "{{receipt}} · Qty {{qty}}",
      "barcodeMode": "This item was printed with Job Work barcode labels — assign a zone/rack location to each one below.",
      "splitMode": "No Job Work barcode labels for this item — split the quantity across as many zone/rack locations as needed.",
      "locationType": "Location Type",
      "typeAll": "All",
      "typeZone": "Zone",
      "typeRack": "Rack",
      "typeBin": "Bin",
      "zone": "Zone",
      "assignAllLocation": "Assign Location to All",
      "assignAllLocationHelper": "Applies this zone/rack to every barcode row below — you can still change individual rows afterward.",
      "itemCode": "Item Code",
      "itemName": "Item Name",
      "barcode": "Barcode",
      "scanBarcode": "Scan Barcode",
      "scanBarcodeHelper": "Scan or type this label's barcode to confirm you're shelving the physical unit in hand.",
      "scannedOfTotal": "{{scanned}} / {{total}}",
      "noBarcodeBlocked": "Barcode Required is enabled in Process Configuration, but this item has no printed Job Work labels. Print labels for this item before putaway can be confirmed.",
      "rowN": "Split {{n}}",
      "location": "Zone / Rack / Bin",
      "addRow": "Split / Add Row",
      "allocatedOf": "Selected: {{allocated}} of {{total}} remaining",
      "mismatchHint": "Selected quantity can't exceed the {{total}} remaining.",
      "exactMismatchHint": "A manual quantity split must add up to exactly {{total}} — partial confirms are only supported for barcode-linked items.",
      "alreadyPutAway": "{{allocated}} of {{total}} already put away in a previous save.",
      "confirmPartial": "Confirm Selected ({{count}})",
      "remarks": "Remarks"
    }
  },
  "labeling": {
    "title": "Job Work Label Print",
    "subtitle": "Print barcode labels for accepted job work stock — labels always print after QC has resolved.",
    "afterQcOnly": "Job Work labels print strictly after the line's QC (if any) has passed — the printable quantity is the line's accepted quantity.",
    "tabs": {
      "print": "Print",
      "reprint": "Reprint"
    },
    "selectionCriteria": "Selection Criteria",
    "selectReceipt": "Job Work Receipt",
    "selectItem": "Item",
    "selectTemplate": "Label Template",
    "noItemsOnReceipt": "No printable items on this receipt — labels print only after QC has passed.",
    "noTemplatesAvailable": "No label templates available for this item.",
    "selectTemplatePrompt": "Select a label template to preview.",
    "noLabelsToPreview": "No labels to preview yet.",
    "itemDetails": "Item Details",
    "itemFields": {
      "batchNo": "Batch No.",
      "acceptedQty": "Accepted Qty",
      "labelPrintedQty": "Already Printed"
    },
    "configuration": "Configuration",
    "mode": {
      "auto": "Auto",
      "manual": "Manual",
      "autoHint": "Splitting {{total}} units into labels of {{stuffingQty}} each.",
      "autoNoStuffingQty": "Printing {{total}} units as one label each (no Stuffing Qty set on this material).",
      "labelN": "Label {{n}}",
      "addLabel": "Add Label",
      "allocatedOf": "Allocated {{allocated}} of {{total}}",
      "mismatchHint": "must equal {{total}} exactly"
    },
    "canvasPreviewTitle": "Label Preview",
    "sendingToPrinter": "Sending to printer...",
    "printLabels": "Print {{count}} Label(s)",
    "sampleMaterial": "Sample Material",
    "history": {
      "title": "Print History",
      "date": "Date",
      "receipt": "Receipt No.",
      "material": "Material",
      "template": "Template",
      "quantity": "Qty",
      "printer": "Printer",
      "user": "Printed By"
    },
    "reprint": {
      "selectionCriteria": "Selection Criteria",
      "noPrintedReceipts": "No receipts have any printed labels yet.",
      "noPrintedItems": "No printed items on this receipt.",
      "noHistory": "No print jobs found for this item.",
      "labelCount": "Labels",
      "reprintButton": "Reprint"
    }
  }
}
